export function formatMoney(n: number, cur: string): string {
  const code = /^[A-Z]{3}$/i.test(cur.trim()) ? cur.trim().toUpperCase() : "USD";
  try {
    return new Intl.NumberFormat("fr-FR", {
      style: "currency",
      currency: code,
      minimumFractionDigits: 2,
    }).format(n);
  } catch {
    return `${n.toFixed(2)} ${code}`;
  }
}
